import MicrosoftIcon from 'components/core/icons/microsoft.svg'
import Image from 'components/core/image'
import React from 'react'

const Microsoft = (): React.ReactElement => {
    return <Image src={MicrosoftIcon.src} height={24} width={24} />
}

export default Microsoft
